import { useFiltersContext } from 'components/FiltersProvider/FiltersProvider';
import { GroupListFilter, GroupListFilterOption } from 'lib/apiClient';
import { useMemo } from 'react';
import { FilterOptions } from '../../FilterOptions/FilterOptions';
import styles from './FilterGroupList.css';

export function FilterGroupList() {
	const { filters, activeFilter } = useFiltersContext();

	const filterGroups = useMemo<GroupListFilterOption[]>(() => {
		return (filters?.find((filter) => filter.key === activeFilter?.key) as GroupListFilter)?.groups;
	}, [filters, activeFilter?.key]);

	return (
		<div>
			{filterGroups?.map((group) => (
				<div key={group.code} className={styles.group}>
					<FilterOptions label={group.label} options={group.options} group={group.code} />
					<span className={styles.divider} />
				</div>
			))}
		</div>
	);
}
